export const applyMask = (value, mask = []) => {
  const rawValue = String(value || '').replace(/\D/g, '');
  let rawIndex = 0;
  let maskedValue = '';

  for (let maskIndex = 0; maskIndex < mask.length && rawIndex < rawValue.length; maskIndex += 1) {
    const maskPart = mask[maskIndex];
    const currentChar = rawValue[rawIndex];

    if (maskPart instanceof RegExp) {
      if (maskPart.test(currentChar)) {
        maskedValue += currentChar;
        rawIndex += 1;
      }
      continue;
    }

    maskedValue += maskPart;
  }

  return maskedValue;
};
